<button (click)="click($event)" [ngClass]="{'w-100': fullWidth,
              'h-100': fullHeight,
              'btn-large': size==='large', 'btn-medium': size==='medium',
              'btn-small': size==='small','btn-color-primary': color==='primary',
              'btn-color-warn': color==='warn','btn-color-default': color==='default','btn-color-accent':
              color==='accent', 'btn-color-transparent':
              color==='transparent', disabled: disabled}">
  <ng-content></ng-content>
</button>
